export default __webpack_public_path__ + "media/src/images/assign_route/edit-19c2df1d027704f69a0e7f30fdecf481.svg";